import type { ReactNode } from 'react';
import styles from '../ScenarioGenerator.module.css';
import type { SceneItemProps } from '../SceneItem';
import { useSceneHandlers } from '../hooks/SceneHandlersContext';
import { SceneNarrationBox } from './SceneNarrationBox';
import { StoryboardMotionCard } from './StoryboardMotionCard';
import { showStoryboardMotionCard } from './storyboardMotionLogic';

type SceneFlowActionsProps = Pick<SceneItemProps, 'scenario' | 'scene' | 'sceneKey'> & {
  /** Step 2 の動画生成ボックス。videoBoxOnly と共有するため SceneItem 側で組み立てる。 */
  videoStepBox: ReactNode;
  /** 絵コンテのモーション上書き (§10.13) の定額 (SceneItem の sceneCredits)。未指定 (テスト等) なら 0 = 料金未設定扱い */
  storyboardMotionCredits?: number;
};

/**
 * シーンカード右列下部のフローアクションエリア (Step 2 動画生成 / Step 3 ナレーション)。
 */
export function SceneFlowActions({
  scenario,
  scene,
  sceneKey: key,
  videoStepBox,
  storyboardMotionCredits = 0,
}: SceneFlowActionsProps) {
  const { videoGenerationMode } = useSceneHandlers();

  return (
    <>
                              {/* ── フローアクションエリア（動画生成・ナレーション） ── */}
                              <div className={styles.flowActionsContainer}>

                                  {/* Step 2: 動画生成。ストーリーボードモードでは
                                      StoryboardCandidates 側に 1 つだけ集約するため非表示 */}
                                  {videoGenerationMode !== 'storyboard' && videoStepBox}

                                  {/* 絵コンテの本編シーンで「モーションで上書き」(3 点メニュー・AI 判定の初期値) のときだけモーションカード
                                      (docs/features/brand-cut-motion-graphics-plan.md §10.13 4.)。× で絵コンテ動画に戻る。ブランドカットは対象外 */}
                                  {showStoryboardMotionCard(videoGenerationMode, scene) && (
                                    <StoryboardMotionCard
                                      scenario={scenario}
                                      scene={scene}
                                      sceneKey={key}
                                      sceneCredits={storyboardMotionCredits}
                                    />
                                  )}

                                  {/* Step 3: ナレーション。歌モノ以外は話者付きの行を読み上げる (分岐は SceneNarrationBox の中)。
                                      ストーリーボードモードでも同じボックスを出す */}
                                  <SceneNarrationBox
                                    scenario={scenario}
                                    scene={scene}
                                    sceneKey={key}
                                  />

                              </div>
    </>
  );
}
